import { TableColumn } from "@components/TableNew/TableColumns";

export function getCopyTableData(columnsRaw: TableColumn[], rowsCount: number): string[][] {
    const columns = columnsRaw
        .filter(column => !column.isHidden && !column.isHiddenForTextMode)
        .map(c => ({
            ...c,
            subColumns: c.subColumns?.filter(subCol => !subCol.isHidden && !subCol.isHiddenForTextMode),
        }));

    const getSubColumnHeads = (columns: TableColumn[]): string[][] => {
        return columns.map(subCol => subCol.subColumns?.length ? getSubColumnHeads(subCol.subColumns) : subCol.headText ?? '') as unknown as string[][];
    };

    const heads = columns.flatMap((column) => {
        if (column.subColumns) {
            return getSubColumnHeads(column.subColumns).flat(Infinity) as string[];
        }
        return [column.headText ?? ''];
    });

    const hasAnyParentHead = columns.some(col => col.subColumns?.length && col.headText !== undefined);

    const parentHeads = hasAnyParentHead
        ? columns.flatMap((column) => {
            if (column.subColumns && column.subColumns.length > 0) {
                const count = column.subColumns.length;
                const parentHeadRow = Array(count).fill('')
                parentHeadRow[0] = column.headText ?? '';
                return parentHeadRow;
            }

            return [''];
        })
        : [];

    const mapColumn = (rowIndex: number) => (column: TableColumn): string | string[] => {
        if (column.subColumns) {
            return column.subColumns.flatMap(mapColumn(rowIndex));
        }

        return column.valueText?.(rowIndex) ?? '';
    }

    const body = Array(rowsCount).fill(0).map((_, rowIndex) =>
        columns.flatMap(mapColumn(rowIndex))
    );

    const copyTableData = [heads, ...body];
    if (hasAnyParentHead) {
        copyTableData.unshift(parentHeads);
    }

    return copyTableData;
}

export function formatCopyDataAsString(data: string[][]): string {
    return data.map(row => row.join('\t')).join('\n');
}
